const GET_RECENT_LOGINS_URI = '/dashboard/getRecentLogins/';

module.exports = {
    /**
     * Get Booking Visits Via Booking ID
     * @param bookingId
     */


    getRecentLogins: function getRecentLogins(pageNumber) {
        return window.axios.get(GET_RECENT_LOGINS_URI, {
            params: {
                pageNumber: pageNumber,
                // break_down_ids: visitBreakDownIds
            }
        });
    }

}